import { Grid } from '@mui/material';
import { isEmpty } from 'lodash-es';

import { EmptyResponseCard } from '../../../../features/candidateLayout/components/childComponets';
import Empty_Templates from '../../../../images/Empty_templates.svg';

import TemplateInfo from './TemplateInfo';

interface TemplatesCardProps {
  jobSubmissionTemplate: string;
  infoTemplates: string[];
  evalutionTemplates: string[];
}

const TemplatesCard = ({
  jobSubmissionTemplate,
  infoTemplates,
  evalutionTemplates,
}: TemplatesCardProps) => {
  const isEmptyTemplates =
    isEmpty(jobSubmissionTemplate) && isEmpty(infoTemplates) && isEmpty(evalutionTemplates);
  return (
    <>
      {!isEmptyTemplates ? (
        <Grid display="flex" direction="column" rowGap={3} py={2}>
          <TemplateInfo title="Evaluation Templates" templates={evalutionTemplates} />
          <TemplateInfo title="Information Templates" templates={infoTemplates} />
          <TemplateInfo title="Submission Template" templates={[jobSubmissionTemplate]} />
        </Grid>
      ) : (
        <EmptyResponseCard
          src={Empty_Templates}
          subText="No template is associated with this job."
          text=""
          sx={{ minHeight: 300 }}
        />
      )}
    </>
  );
};

export default TemplatesCard;
